import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, ParaSubtitle, Pagination } from "../common";
import { Typography } from "@mui/material";

const GraphicalReports = () => {
  return (
    <div>
      <PageTitle title='Graphical Reports' role='Risk Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Admins/Approvers have access to many kinds of reports which are in graph and text formats regarding the events, locations and categories. These reports can be accessed by clicking on reports tab as shown.' />
      <ParaImageDialog src='/tutorial_image/graphical-reports-1.png' />

      <ParaTitle paraTitle='Graph Reports' />
      <Paragraph paragraph='Graph reports are graphical representation of events, categories for selected periods of time. There are 3 major kinds of graph reports as follow.' />

      <ParaSubtitle paraSubtitle='Summary Of Event Types' />
      <Paragraph paragraph='Displays a summary of all the event categories for the years selected. Click on "Print Page" to print the current report page. Click on "Export Table" to export the report table of the graph in multiple formats like HTML,CSV,Text,Excel,PDF. The graph consists of "Event Categories" along the horizontal axis and "total" number of events along the vertical axis. The selected years will be displayed below the graph and in different colors for each year. "Report table" at the bottom can be sorted by clicking on column headings.' />
      <ParaImageDialog src='/tutorial_image/graphical-reports-2.png' />
      <Paragraph paragraph='Click on "Settings" option, provided for every report, which will have options to customize the report content and display content.' />
      <ol>
        <Typography variant="body1" component="li">
          "Time/Type" option will let the user change the type the graph between Bar or Line. Date range can be modified to display results accordingly. Group By option will let you group the data with options None, Monthly, Quarterly and Yearly.
          <ParaImageDialog src='/tutorial_image/graphical-reports-3.png' />
        </Typography>
        <Typography variant="body1" component="li">
          "Events" options lets the user choose Event status All, Open or Closed. Event type as desired, Event category as desired.
          <ParaImageDialog src='/tutorial_image/graphical-reports-4.png' />
        </Typography>
        <Typography variant="body1" component="li">
          "Benchmark" options helps user decide filters for data to be displayed. Finally click on "Create Report" to display the results.
          <ParaImageDialog src='/tutorial_image/graphical-reports-5.png' />
        </Typography>
      </ol>


      <ParaSubtitle paraSubtitle='Event Locations' />
      <Paragraph paragraph='This report contains graph to display all the events along horizontal axis and total of every event along vertical axis of the graph. "Text table" below the graph has text format of the report and data can be sorted by clicking on column headings and can be exported by clicking on "Export Table" and then select which format the report should be downloaded in.' />
      <ParaImageDialog src='/tutorial_image/graphical-reports-6.png' />
      <Paragraph paragraph='Click on "settings" to manage the report and display content. "Benchmark" under settings has additional "Location Benchmarking" option for this report to filter information by "check/uncheck" of various locations for the events.' />
      <ParaImageDialog src='/tutorial_image/graphical-reports-7.png' />

      <ParaSubtitle paraSubtitle='Event Category Trending' />
      <Paragraph paragraph='This report displays the trending events by categories for defined period. The report contains graph to display the date/month along horizontal axis and total of every event along vertical axis of the graph. "Text table" below the graph has detailed text format of the report and data can be sorted by clicking on column headings and can be exported by clicking on "Export Table" and then select the format the report should be downloaded in.' />
      <ParaImageDialog src='/tutorial_image/graphical-reports-8.png' />
      <Paragraph paragraph='Details of events for a any day can also be checked by hovering cursor over one of the colored lines in the graph' />
      <ParaImageDialog src='/tutorial_image/graphical-reports-9.png' />

      <Pagination
        pagination={{
          prev: { name: 'Dashboard Reports', link: '/reports/dashboard-reports' },
          next: { name: 'Text Reports', link: '/reports/text-reports' }
        }}
      />
    </div>
  );
};

export default GraphicalReports;
